var _excluded = ["invalid", "isLoading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRef, useState } from 'react';
import { forwardRef } from '../../../utils';
import { fileTypes } from '../../../utils/get-input-file-accept';
import { _BaseFileUpload } from '../../internal';
import { getPreviewFileMetadata, previewDataURLFile } from '../../internal/_BaseFileUpload/_BaseFileUpload.utils';
import { IFrame } from '../../internal/IFrame';
import { Image } from '../../media';
import { jsx as _jsx } from "react/jsx-runtime";
export var LargeFileUpload = forwardRef((_ref, ref) => {
  var _props$value, _props$placeholder;

  var {
    invalid,
    isLoading
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [fileDataURL, setFileDataURL] = useState(null);
  var hiddenFileInputRef = useRef(null);
  var [selectedFile, setSelectedFile] = useState((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : null);
  var previewFileMetadata = getPreviewFileMetadata(selectedFile, fileDataURL);
  var previewFileComponent = previewFileMetadata && (previewFileMetadata.type === fileTypes.pdf ? /*#__PURE__*/_jsx(IFrame, {
    title: previewFileMetadata.name,
    src: "".concat(previewFileMetadata.url, "#view=fit"),
    height: "100%",
    width: "100%",
    onClick: () => previewDataURLFile(previewFileMetadata.url)
  }) : /*#__PURE__*/_jsx(Image, {
    height: "100%",
    objectFit: "contain",
    alt: previewFileMetadata.name,
    title: previewFileMetadata.name,
    src: previewFileMetadata.url,
    onClick: () => previewDataURLFile(previewFileMetadata.url)
  }));
  return /*#__PURE__*/_jsx(_BaseFileUpload, _objectSpread(_objectSpread({
    ref: ref,
    "data-component": "LargeFileUpload",
    as: isLoading ? 'div' : 'button',
    selectedFile: selectedFile,
    setSelectedFile: setSelectedFile,
    setFileDataURL: setFileDataURL,
    hiddenFileInputRef: hiddenFileInputRef,
    placeholder: (_props$placeholder = props.placeholder) !== null && _props$placeholder !== void 0 ? _props$placeholder : 'Browse to upload your invoice image/file',
    isInvalid: invalid === null || invalid === void 0 ? void 0 : invalid.isInvalid,
    isLoading: isLoading,
    errorMessage: invalid === null || invalid === void 0 ? void 0 : invalid.errorMessage,
    size: "large",
    onOpenImagePreview: () => previewFileMetadata && (previewFileMetadata.type === fileTypes.pdf ? previewDataURLFile(previewFileMetadata.url) : previewDataURLFile(previewFileMetadata.url))
  }, props), {}, {
    children: previewFileComponent
  }));
});
LargeFileUpload.displayName = 'LargeFileUpload';
//# sourceMappingURL=LargeFileUpload.js.map